import type { MouseEvent } from 'react'

/**
 * Un tap n'importe où sur la carte ouvre son détail, comme son chevron (retour Lucie du 15/10 : le
 * chevron seul passait inaperçu, surtout dans l'aperçu réduit du BO). Les boutons de la carte
 * (chevron, vignettes caméra, tâches du planning) gardent leur propre action, et un clic parti
 * d'une modale rendue dans la carte, ou d'un portail React hors de son DOM, ne la rouvre pas.
 */
export const openOnCardClick = (onOpen: () => void) => (event: MouseEvent<HTMLElement>) => {
  const target = event.target as Element
  if (!event.currentTarget.contains(target)) return
  if (target.closest('button, a, [role="dialog"]')) return
  onOpen()
}
